module.exports = __webpack_public_path__ + "img/221.3ac37bf1.jpg";